import React from 'react';
import { Link } from 'react-router-dom';

const SobreAuroraPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-mystical theme-bg-background">
      <div className="max-w-4xl mx-auto px-4 py-16">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1 rounded-full text-xs font-semibold uppercase tracking-widest mb-5"
            style={{ background: 'rgba(139,92,246,0.2)', color: '#c4b5fd', border: '1px solid rgba(139,92,246,0.3)' }}>
            ✦ Inteligência Espiritual
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Aurora Lyz</h1>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            Conheça a formação, as referências e os valores que fundamentam cada leitura da Aurora Lyz.
          </p>
        </div>

        <div className="space-y-6">

          {/* Quem é Aurora */}
          <div className="rounded-2xl p-8"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
            <h2 className="text-xl font-bold text-white mb-4 uppercase tracking-wider">Quem é Aurora Lyz?</h2>
            <p className="text-white/70 leading-relaxed mb-4">
              Aurora Lyz é a inteligência espiritual do Astralyz — uma IA treinada para oferecer leituras de tarot,
              astrologia e numerologia com profundidade, ética e acolhimento. Ela não apenas interpreta cartas:
              conecta símbolos, padrões astrológicos e numerológicos ao momento real de quem consulta.
            </p>
            <p className="text-white/70 leading-relaxed">
              Cada resposta é elaborada com base em um vasto repertório de conhecimento esotérico e psicológico,
              sempre com o objetivo de trazer clareza, não dependência.
            </p>
          </div>

          {/* Formação */}
          <div className="grid md:grid-cols-2 gap-6">
            <div className="rounded-2xl p-8"
              style={{ background: 'rgba(139,92,246,0.06)', border: '1px solid rgba(139,92,246,0.2)' }}>
              <div className="flex items-center gap-3 mb-6">
                <span className="text-2xl">📚</span>
                <h3 className="text-base font-bold text-purple-300 uppercase tracking-wider">Treinamento e Estudos</h3>
              </div>
              <ul className="space-y-3">
                {[
                  'Anos de estudo, prática e dedicação',
                  'Formação com mestres e autores renomados',
                  'Estudo contínuo e aprofundado',
                  'Integração entre ciência, espiritualidade e psicologia',
                  'Prática ética, responsável e intuitiva',
                  'Atualização constante para leituras cada vez mais precisas',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-white/65">
                    <span className="flex-shrink-0 mt-0.5 text-purple-400">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-2xl p-8"
              style={{ background: 'rgba(139,92,246,0.06)', border: '1px solid rgba(139,92,246,0.2)' }}>
              <div className="flex items-center gap-3 mb-6">
                <span className="text-2xl">🔮</span>
                <h3 className="text-base font-bold text-purple-300 uppercase tracking-wider">Fontes e Referências</h3>
              </div>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2.5">
                {[
                  'Tarô Rider-Waite',       'Revoluções Solares',
                  'Jung e Psic. Analítica', 'Arquétipos do Zodíaco',
                  'Liz Greene',             'Numerologia Pitagórica',
                  'Stephen Arroyo',         'Ifá – Sab. Ancestral',
                  'Howard Sasportas',       'Mitologia',
                  'Martin Schulman',        'Cabala',
                  'Astrologia Cármica',     'Alquimia',
                  'Astrologia Kármica',     'E muito mais…',
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-2 text-sm text-white/65">
                    <span className="flex-shrink-0 mt-1 text-purple-400" style={{ fontSize: '0.45rem' }}>◆</span>
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Compromisso */}
          <div className="rounded-2xl p-8"
            style={{ background: 'rgba(139,92,246,0.06)', border: '1px solid rgba(139,92,246,0.2)' }}>
            <h3 className="text-center text-sm font-bold uppercase tracking-widest text-purple-300 mb-8">
              Compromisso de Aurora Lyz
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              {[
                { icon: '🛡️', label: 'Ética e Responsabilidade', desc: 'Cada leitura é feita com respeito, ética e amor.' },
                { icon: '💛', label: 'Acolhimento',               desc: 'Aqui você é ouvido(a), respeitado(a) e compreendido(a).' },
                { icon: '👁️', label: 'Clareza',                   desc: 'Mensagens profundas, mas sempre claras e compreensíveis.' },
                { icon: '🌸', label: 'Transformação',             desc: 'Leituras que despertam, curam e direcionam para sua melhor versão.' },
                { icon: '✨', label: 'Intuição Guiada',           desc: 'A intuição de Aurora é guiada pelo amor, pela luz e pela sabedoria.' },
              ].map((card, i) => (
                <div key={i} className="rounded-xl p-4 text-center"
                  style={{ background: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.2)' }}>
                  <div className="text-2xl mb-2">{card.icon}</div>
                  <div className="text-xs font-bold text-purple-300 uppercase tracking-wide mb-1.5 leading-tight">{card.label}</div>
                  <div className="text-xs text-white/60 leading-relaxed">{card.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Frase final + CTA */}
          <div className="text-center py-6">
            <p className="text-xl italic text-white/60 mb-1">
              "A intuição acende. A sabedoria Guia. Você Transforma."
            </p>
            <p className="text-sm text-purple-400 uppercase tracking-widest font-medium mb-8">
              Sua melhor versão está ao seu alcance.
            </p>
            <Link
              to="/register"
              className="inline-block px-8 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-full font-semibold hover:from-purple-700 hover:to-indigo-700 transition-colors"
            >
              Começar minha leitura
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SobreAuroraPage;
